module.exports = __webpack_public_path__ + "img/3bdf0930adc796069f7bf974f0abbc95.png";